import get from 'lodash/get';

export function getSections(orderedSections, state, errors) {
  const result = {};
  const indexes = {};

  orderedSections.forEach((section, i) => {
    indexes[section] = i;
    result[section] = {
      title: section,
      fields: [],
      errors: [],
    };
  });

  Object.entries(state).forEach(([field, section]) => {
    if (!result[section]) {
      return;
    }

    result[section].fields.push({
      name: field,
    });

    if (get(errors, field)) {
      result[section].errors.push({
        field,
        message: get(errors, field),
      });
    }
  });

  return Object.values(result).sort(
    (a, b) => indexes[a.title] - indexes[b.title],
  );
}
